import React from "react";
import { Link } from "react-router-dom";

const PromotionalTwo = () => {
  return (
    <section
      className="offer"
      style={{
        background: "linear-gradient(135deg, #f9fafc, #ffffff)",
        padding: "100px 0",
      }}
    >
      <div className="container container-lg">
        {/* === Section Header === */}
        <div className="text-center mb-5">
          <h4
            style={{
              fontWeight: "700",
              color: "#111",
              marginBottom: "15px",
              fontSize: "32px",
              letterSpacing: "0.5px",
            }}
          >
            Featured Products for Every Need
          </h4>
          <p
            style={{
              fontSize: "16px",
              color: "#555",
              maxWidth: "700px",
              margin: "0 auto",
              lineHeight: "1.8",
            }}
          >
            Explore top-rated printers and supplies from{" "}
            <span style={{ color: "#3446b8", fontWeight: "600" }}>
              Printing Dealz
            </span>
            , perfectly chosen for home offices and businesses seeking quality,
            reliability, and performance every day.
          </p>
        </div>

        {/* === Cards Section === */}
        <div
          className="row gy-4 justify-content-center"
          style={{ marginTop: "60px" }}
        >
          {/* === Card 1 === */}
          <div className="col-sm-6">
            <div
              className="offer-card position-relative overflow-hidden text-white"
              style={{
                borderRadius: "20px",
                background: "linear-gradient(135deg, #3446b8 0%, #b71c1c 100%)",
                padding: "50px 40px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
                transition: "all 0.4s ease",
                height: "100%",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "0 18px 40px rgba(0,0,0,0.18)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.12)";
              }}
            >
              <img
                src="assets/images/shape/offer-shape.png"
                alt=""
                className="position-absolute w-100 h-100"
                style={{
                  top: 0,
                  left: 0,
                  opacity: 0.15,
                  objectFit: "cover",
                }}
              />

              <div
                className="d-flex align-items-center flex-wrap"
                style={{
                  gap: "40px",
                  alignItems: "center",
                }}
              >
                <div
                  className="offer-card__logo flex-center bg-white rounded-circle"
                  style={{
                    width: "90px",
                    height: "90px",
                    boxShadow: "0 0 10px rgba(255,255,255,0.4)",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src="assets/images/thumbs/printer.png"
                    alt=""
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>

                <div>
                  <h4
                    className="mb-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "35px",
                      marginBottom: "10px",
                      color: "#fff",
                    }}
                  >
                    Home Printer Collection
                  </h4>
                  <p
                    style={{
                      color: "#fff",
                      opacity: 0.9,
                      fontSize: "15px",
                      marginBottom: "25px",
                    }}
                  >
                    Reliable, affordable printers for family use
                  </p>

                  <Link
                    to="/home-printers"
                    className="btn d-inline-flex align-items-center gap-2"
                    style={{
                      color: "#fff",
                      fontWeight: "600",
                      borderRadius: "50px",
                      padding: "12px 28px",
                      background: "linear-gradient(135deg, #3446b8, #b71c1c)",
                      transition: "all 0.3s ease",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(183, 28, 28, 0.3)",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #b71c1c, #7f0000)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 16px rgba(183, 28, 28, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #3446b8, #b71c1c)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(183, 28, 28, 0.3)";
                    }}
                  >
                    Shop Now
                    <i
                      className="ph ph-shopping-cart-simple"
                      style={{
                        fontSize: "18px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* === Card 2 === */}
          <div className="col-sm-6">
            <div
              className="offer-card position-relative overflow-hidden text-white"
              style={{
                borderRadius: "20px",
                background: "linear-gradient(135deg, #283593 0%, #1a237e 100%)",
                padding: "50px 40px",
                boxShadow: "0 8px 25px rgba(0,0,0,0.12)",
                transition: "all 0.4s ease",
                height: "100%",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow =
                  "0 18px 40px rgba(0,0,0,0.18)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.12)";
              }}
            >
              <img
                src="assets/images/shape/offer-shape.png"
                alt=""
                className="position-absolute w-100 h-100"
                style={{
                  top: 0,
                  left: 0,
                  opacity: 0.15,
                  objectFit: "cover",
                }}
              />

              <div
                className="d-flex align-items-center flex-wrap"
                style={{
                  gap: "40px",
                  alignItems: "center",
                }}
              >
                <div
                  className="offer-card__logo flex-center bg-white rounded-circle"
                  style={{
                    width: "90px",
                    height: "90px",
                    boxShadow: "0 0 10px rgba(255,255,255,0.4)",
                    flexShrink: 0,
                  }}
                >
                  <img
                    src="assets/images/thumbs/printer.png"
                    alt=""
                    style={{ width: "50px", height: "50px" }}
                  />
                </div>

                <div>
                  <h4
                    className="mb-2"
                    style={{
                      fontWeight: "700",
                      fontSize: "30px",
                      marginBottom: "10px",
                      color: "#fff",
                    }}
                  >
                    Office Printer Solutions
                  </h4>
                  <p
                    style={{
                      color: "#fff",
                      opacity: 0.9,
                      fontSize: "15px",
                      marginBottom: "25px",
                    }}
                  >
                    High-performance laser printers for business
                  </p>

                  <Link
                    to="/office-printers"
                    className="btn d-inline-flex align-items-center gap-2"
                    style={{
                      color: "#fff",
                      fontWeight: "600",
                      borderRadius: "50px",
                      padding: "12px 28px",
                      background: "linear-gradient(135deg, #3949ab, #1a237e)",
                      transition: "all 0.3s ease",
                      border: "none",
                      boxShadow: "0 4px 10px rgba(26, 35, 126, 0.3)",
                      textDecoration: "none",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #1a237e, #0d133f)";
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.boxShadow =
                        "0 8px 16px rgba(26, 35, 126, 0.4)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.background =
                        "linear-gradient(135deg, #3949ab, #1a237e)";
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(26, 35, 126, 0.3)";
                    }}
                  >
                    Shop Now
                    <i
                      className="ph ph-shopping-cart-simple"
                      style={{
                        fontSize: "18px",
                        transition: "transform 0.3s ease",
                      }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalTwo;
